import { Col, Row, Table } from 'reactstrap';
import { ContentBlock } from '../../Shared/Content/ContentBlock';
import { ContentHeading } from '../../Shared/Content/ContentHeading';
import { ContentBody } from '../../Shared/Content/ContentBody';

export const Costs = () => {
    return (
        <div id="costs">
            <ContentBlock className="evSupplyEquipmentSection">
                <ContentHeading title="Electric Vehicle Supply Equipment Costs" />
                <ContentBody>
                    <div className="heading5">
                        When investing in EVs, you have to consider the infrastructure you need to keep them fully charged and on the road, known as electric vehicle supply equipment (EVSE).
                    </div>
                    <Row className="tableBlock">
                        <Col>
                            <Table responsive className="evSupplyEquipmentCosts">
                                <caption>Capital Costs (Nonresidential)</caption>
                                <thead>
                                    <tr>
                                        <th rowSpan={2} className={"surface7Background"}>Cost Per Port</th>
                                        <th colSpan={2}>Level 1</th>
                                        <th colSpan={2}>Level 2</th>
                                        <th colSpan={2}>DC Fast Charger</th>
                                    </tr>
                                    <tr>
                                        <th className="subheading">Low</th>
                                        <th className="subheading">High</th>
                                        <th className="subheading">Low</th>
                                        <th className="subheading">High</th>
                                        <th className="subheading">Low</th>
                                        <th className="subheading">High</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th className="text-left subheading">Hardware</th>
                                        <td>$300</td>
                                        <td>$1,500</td>
                                        <td>$400</td>
                                        <td>$6,500</td>
                                        <td>$4,000</td>
                                        <td>$150,000</td>
                                    </tr>
                                    <tr>
                                        <th className="text-left subheading">Permitting</th>
                                        <td>$100</td>
                                        <td>$500</td>
                                        <td>$100</td>
                                        <td>$1,000</td>
                                        <td>$500</td>
                                        <td>$1,000</td>
                                    </tr>
                                    <tr>
                                        <th className="text-left subheading">Installation</th>
                                        <td>$100</td>
                                        <td>$3,500</td>
                                        <td>$600</td>
                                        <td>$20,000</td>
                                        <td>$20,000</td>
                                        <td>$90,000</td>
                                    </tr>
                                    <tr>
                                        <th className="text-left subheading">Total</th>
                                        <td><strong>$500</strong></td>
                                        <td><strong>$5,500</strong></td>
                                        <td><strong>$1,100</strong></td>
                                        <td><strong>$27,500</strong></td>
                                        <td><strong>$24,500</strong></td>
                                        <td><strong>$241,000</strong></td>
                                    </tr>
                                </tbody>
                            </Table>
                            <div className="disclaimer">
                                Sources: U.S. Department of Energy, EPRI, New York State Energy Research and Development Authority, Rocky Mountain Institute
                            </div>

                            <div className="subContent">
                                <h4 className="css_heading bold">Operational Costs</h4>
                                <div className="body indent">
                                    <p>
                                        <h5 className="css_heading bold">Electricity</h5>
                                        <ul>
                                            <li>Charges per kilowatt-hour (kWh), plus any demand charges (that is, charges for the highest rate of electrical demand over a 15-minute interval).</li>
                                            <li>DC fast charger equipment is more likely to trigger demand charges than Level 1 and Level 2 chargers.</li>
                                        </ul>
                                    </p>
                                </div>
                                <div className="body indent">
                                    <p>
                                        <h5 className="css_heading bold">Maintenance and Warranty</h5>
                                        <ul>
                                            <li>Manufacturers offer extended warranties and maintenance plans that can reduce the costs of maintenance, repairs, and hardware replacement.</li>
                                            <li>Warranty and maintenance pricing varies, but the average cost is about $400 annually per port.</li>
                                            <li>Repairing broken chargers can be costly if they are no longer under warranty.</li>
                                        </ul>
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>

                </ContentBody>
            </ContentBlock>
        </div>
    );

};
